<template>
  <item :title="title" :subTitle="subtitle" iconClass="ogc-icon-anquan" :isActive="isActive">
    <template slot="buttons">
      <el-button class="button" type="primary" round plain @click="onShow">修改密码</el-button>
    </template>

    <fc-dialog title="修改密码" :visible.sync="visible" v-if="phone != null">

      <div>
        <el-steps :active="templateIndex" finish-status="success" align-center>
          <el-step title="认证方式"></el-step>
          <el-step title="安全认证"></el-step>
          <el-step title="修改新密码"></el-step>
        </el-steps>
      </div>

      <template v-if="templateIndex == 0">
        <el-alert show-icon title="认证方式"
                  :description="step1Description" type="info" effect="dark"></el-alert>

        <div class="types">
          <div class="type-item" :class="{ active: vtype == 0 }" @click="changeType(0)">
            <div class="icon"><img src="/static/images/me/verify-by-phone.png" alt=""></div>
            <h3>通过手机验证</h3>
            <p>使用手机 {{ phone }} 验证</p>
          </div>
          <div class="type-item" :class="{ active: vtype == 1 }" @click="changeType(1)" v-if="canEmail">
            <div class="icon"><img src="/static/images/me/verify-by-email.png" alt=""></div>
            <h3>通过邮箱验证</h3>
            <p>使用邮箱 {{ email }} 验证</p>
          </div>
        </div>

      </template>
      <template v-if="templateIndex == 1">
        <el-alert show-icon title="现在进行安全认证" v-if="vtype == 0"
                  description="我们刚刚发送了一条短信到您的手机上，请输入短信中的验证码。" type="warning" effect="dark"></el-alert>
        <el-alert show-icon title="现在进行安全认证" v-else
                  description="我们刚刚发送了一封邮件到您的邮箱，请输入邮件中的六位验证码。" type="warning" effect="dark"></el-alert>

        <auto-form ref="form1" :rules="rules[1]" :form="form" :form-template="formTemplate[1]"
                   :url="url.validateVCode"></auto-form>
      </template>
      <template v-if="templateIndex == 2">
        <el-alert show-icon title="恭喜！安全验证成功！"
                  description="请输入您的新密码，必须同时包含大小写字母及数字，且长度最少6位。" type="success" effect="dark"></el-alert>

        <auto-form ref="form2" :rules="rules[2]" :form="form" :form-template="formTemplate[2]" :url="url.save"
                   @beforeSave="beforeSave" @afterSaved="afterSaved"
                   @saved="onSaved" :canEdit="true" :isEdit="false"></auto-form>
      </template>


      <div slot="footer" class="dialog-footer">
        <el-button type="warning" :disabled="uploading" plain @click="cancel"> 取 消</el-button>
        <el-button type="primary" :disabled="uploading" @click="next" v-if="templateIndex < 2"> 下一步</el-button>
        <el-button type="success" :disabled="uploading" @click="next" v-else> 确认更改</el-button>
      </div>
    </fc-dialog>
  </item>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'
import FcDialog from '@/components/Dialogs/Dialog'
import Item from './OptionItem'

export default {
  components: {
    Item, FcDialog, AutoForm
  },
  props: {
    phone: {
      type: String,
      default: null
    },
    oldPassword: {
      type: String,
      default: null
    },
    phoneStr: {
      type: String,
      default: null
    },
    CustomId: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    password: {
      type: Number,
      default: 0
    },
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    //两次密码验证
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入密码'));
    //   } else {
    //     if (this.form.Password !== '') {
    //       this.$refs.form2.validateField('RePassword');
    //     }
    //     callback();
    //   }
    // };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.Password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      uploading: false,
      vtype: 0,
      form: {Password: '', RePassword: '', vcode: ''},
      formTemplate: [
        [],
        [
          {col: 24, tips: '安全认证', type: 'tips'},
          {col: 24, label: '短信验证码', prop: 'vcode'},
        ],
        [
          {col: 24, tips: '修改新密码', type: 'tips'},
          {col: 24, label: '新密码', prop: 'Password', type: 'password'},
          {col: 24, label: '确认密码', prop: 'RePassword', type: 'password'},
        ]
      ],
      rules: [
        {},
        {
          vcode: [
            {
              required: true,
              message: '请输入短信验证码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 6,
              message: '验证码长度应为为 6 位',
              trigger: 'blur'
            }
          ]
        },
        {
          Password: [
            {
              required: true,
              message: '请输入登录密码',
              trigger: 'blur'
            },
            {
              validator: validatePassword,
              trigger: 'blur'
            }
          ],
          RePassword: [
            {required: true, message: '请再次输入登录密码', trigger: 'blur' }
          ]
        }
      ],
      url: {
        validateVCode: SZH.assets.api + "/Custom/CheckVerifyCodeForPassword",
        savePWD: SZH.assets.api + "/Custom/UpdateCustomPassword",
        sendPhoneVCodeOld: SZH.assets.api + "/Custom/SendVerifyCodeForWeb",
        sendEmailVCodeOld: SZH.assets.api + "/Authen/SendEmailCode2",
      },
      templateIndex: 0,
      sendOk: false
    }
  },
  methods: {
    next() {
      var self = this;
      if (self.templateIndex == 0) {
        if (self.vtype == 0) {
          self.sendPhoneVCodeOld();
        } else {
          self.sendEmailVCodeOld();
        }
      } else if (self.templateIndex == 1) {
        self.verify();
      } else {
        self.save();
      }
    },
    sendPhoneVCodeOld() {
      var self = this;
      self.uploading = true;
      self.$http.post(self.url.sendPhoneVCodeOld, {
        SmsTemplateType: 3,
        Phone: self.phoneStr,
        CustomId: self.CustomId,
        OldPassword: self.oldPassword,
        Captcha: '',
      }).then(result => {
        if (result.state == true) {
          self.sendOk = true;
          self.$message.success("验证码发送成功！");
          self.templateIndex++;
        } else {
          self.$message.error(result.message);
        }
        self.uploading = false;
      }, () => {
        self.uploading = false;
      });
    },
    sendEmailVCodeOld() {
      var self = this;
      self.uploading = true;
      self.$http.post(self.url.sendEmailVCodeOld, {
        Template: 4
      }).then(result => {
        if (result.State == 1) {
          self.sendOk = true;
          self.$message.success("验证码发送成功！");
          self.templateIndex++;
        } else {
          self.$message.error(result.Message);
        }
        self.uploading = false;
      }, () => {
        self.uploading = false;
      });
    },
    verify() {
      var self = this;
      self.$refs['form1'].validate(valid => {
        if (valid) {
          self.uploading = true;
          self.$http.post(self.url.validateVCode, {
            VCode: self.form.vcode,
            Phone: self.phoneStr,
            OldPassword: self.oldPassword,
            CustomId: self.CustomId,
            SmsTemplateType: 3,
          }).then(result => {
            if (result.state == true) {
              self.$message.success("验证成功！");
              self.form.vcode = '';
              self.templateIndex++;
            } else {
              self.$message.error(result.message);
            }
            self.uploading = false;
          }, () => {
            self.uploading = false;
          });
        } else {
          return false;
        }
      });
    },
    save() {
      if (!this.form.Password) {
        this.$message.error('请输入登录密码');
        return
      }
      if (this.form.Password !== this.form.RePassword) {
        this.$message.error('两次输入的密码不一致请重新输入');
        return
      }
      let regex = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (!regex.test(this.form.Password)) {
        this.$message.error('密码强度不符合要求，请包含字母大小写和数字！');
        return
      }
      // let arr = ['000','111','222','333','444','555','666','777','888','999','123','234','345','456','567','678','789'];
      // let flag = arr.some(item=>{
      //   return this.form.Password.indexOf(item) >-1
      // });
      // if(flag){
      //   this.$message.error('密码强度太弱，禁止（111，123）这种连续重复数字格式！');
      //   return
      // }
      this.form.Password = hex_md5(this.form.Password);
      this.form.RePassword = hex_md5(this.form.RePassword);
      this.loading = true;
      this.$http.post(this.url.savePWD, {
        CustomId: this.CustomId,
        Phone: this.phone,
        OldPassword: this.oldPassword,
        Password: this.form.Password,
        ConfirmPassword: this.form.RePassword,
        SmsTemplateType: 3
      }).then(result => {
        if (result.state == true) {
          this.loading = false;
          this.onSaved()
        } else {
          this.loading = false;
          this.$message.error(result.message)
        }
      })
    },
    beforeSave() {
      this.loading = true;
    },
    afterSaved() {
      this.loading = false;
    },
    onSaved() {
      this.$message.success("密码修改成功! 即将跳转到登录界面，请重新登录。");
      this.visible = false;
      this.$emit('saved');

      setTimeout(() => {
        this.$router.push({
          path: '/LoginTH'
        });
      }, 1000);
    },
    onShow() {
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    changeType(val) {
      this.vtype = val;
    }
  },
  computed: {
    title() {
      return this.password >= 10 ? '密码强度较高' : '密码强度较低';
    },
    subtitle() {
      return this.password >= 10 ? '您的密码强度较高，但也要养成定期修改的好习惯' : '您的密码强度较低，建议修改密码，增加密码复杂度';
    },
    isActive() {
      return true;
    },
    step1Description() {
      return '您正在为帐号 ' + this.username + ' 修改密码，请选择身份验证方式'
    },
    canEmail() {
      return this.email != null;
    }
  },
  created() {
  },
  mounted() {

  },
  watch: {
    visible(val) {
      if (val) {
        this.templateIndex = 0;
        for (var i in this.form) {
          this.form[i] = '';
        }
      }
    }
  }
}
</script>

<style type="text/css" scoped>

.button {
  padding: 5px 10px;
}

.types {
  overflow: hidden;
  margin-top: 30px;
}

.type-item {
  width: calc(50% - 20px);
  border: 1px solid #CCC;
  padding: 30px 10px;
  text-align: center;
  float: left;
  cursor: pointer;
}

.type-item + .type-item {
  float: right;
}

.type-item:only-child {
  float: none;
  margin: 0 auto;
}


.type-item.active {
  border: 3px solid #0A529C;
}

.type-item > .icon {
  height: 150px;
  line-height: 150px;
}

.type-item:last-child > .icon {
  padding-top: 20px;
}

.type-item > h3 {
  font-weight: 700;
  line-height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/ChangePassword.vue